import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';

export const TextButton = styled(Text14)`
  padding: 6px 10px;
  display: block;
  color: inherit;
`;
